import { FETCHED as FETCHED_USER } from '../user/actions'
import { FETCHED_ALL, FETCHED_ONE, UPDATE, ADD, REMOVE } from './actions'

export default function reducer(
  state = { entities: {}, result: [] },
  action = {},
) {
  const { payload = {}, type } = action
  const { result, entities } = payload

  switch (type) {
    case ADD:
      return {
        ...state,
        entities: {
          ...state.entities,
          [result]: entities.petParents[result],
        },
        result: [...state.result, result],
      }
    case REMOVE:
      return {
        ...state,
        result: [...state.result.filter((id) => id !== result)],
        entities: {
          ...state.entities,
          [result]: undefined,
        },
      }
    default:
      return state
  }
}
